import React from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import moment from 'moment'
import { LabeledText } from 'components/misc'
import { ProfileFields } from 'containers/forms/participant'
import { FormattedMessage } from 'react-intl'

const PaymentInfoQuestions = ({ questions = [], profileOptions, isEditing }) => {
  let answerList = []

  profileOptions.forEach(pq => {
   const answer = questions.find(answer => pq.id === get(answer, 'profileQuestion.id'))

    if (answer) {
     const item = {
        id:get(answer, 'id'),
        parentalConsentHide: get(answer, 'profileQuestion.parentalConsentHide'),
        questionType: get(answer, 'profileQuestion.questionType'),
        valueAsString: get(answer, 'valueAsString'),
        optionTranslatedText: get(answer, 'profileQuestionOption.translatedText'),
        translatedText: get(answer, 'profileQuestion.translatedText')
      }
        answerList.push(item)
      } else {
      const item = {
        id:get(pq,'id'),
        parentalConsentHide: get(pq, 'parentalConsentHide'),
        parentalConsentOnly: get(pq, 'parentalConsentOnly'),
        questionType: get(pq, 'questionType'),
        valueAsString: get(pq, 'valueAsString'),
        optionTranslatedText: get(pq, 'profileQuestionOption.translatedText'),
        translatedText: get(pq, 'translatedText')
      }

        answerList.push(item)
      }
  })

  return (isEditing
    ? <ProfileFields parentalConsent={true} questions={profileOptions} />
    : <div>
      {answerList &&
      answerList.map(question => {
            if (get(question, 'parentalConsentHide')) {
              return
            }

            let value

            const type = get(question, 'questionType')

            if (type === 'DATE') {
              value = moment(get(question, 'valueAsString')).format('LL')
            } else if (type === 'OPTIONS') {
              value = get(question, 'optionTranslatedText', '')
            } else {
              value = get(question, 'valueAsString', '')
            }

        if (get(question, 'parentalConsentOnly')) {
          value = <FormattedMessage
            id="label.need_to_be_answered_by_parent"
            defaultMessage="Question need to be answered by parent/guardian"
          />
        }
            return (
              <LabeledText
                key={question.id}
                label={get(
                  question,
                  'translatedText',
                  ''
                ).replace(':', '')}
                value={value}
                warningValue={get(question, 'parentalConsentOnly')}
              />
            )
          })}
    </div>)
}

PaymentInfoQuestions.propTypes = {
  questions: PropTypes.array,
  profileOptions: PropTypes.array,
  isEditing: PropTypes.bool
}

PaymentInfoQuestions.displayName = 'PaymentInfoQuestions'

export default PaymentInfoQuestions
